// src/api/axiosInstance.js   ← create this file
import axios from 'axios';
// import { useNavigate } from 'react-router-dom';   // ← only if needed inside component

const API_URL = process.env.REACT_APP_ASP_URL;

// Create a singleton instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 15000,           // optional but good practice
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor – adds token to EVERY request
axiosInstance.interceptors.request.use(
  (config) => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    if (userData?.token)
      config.headers.Authorization = `Bearer ${userData.token}`;
    if (userData?.user_id)
      config.headers.user_id = userData.user_id;

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor – catches 401 globally
axiosInstance.interceptors.response.use(
  (response) => response,   // successful responses pass through

  (error) => {
    // Check for 401 – you can also check 403 if needed
    if (error.response?.status === 401) {
      // Clear all auth data
      const userData = {
        user_id: null,
        token: null,
        user_name: null,
        user_profile: null,
        user_store_id: null,
        user_perm_id: [],
        fiscal_year: new Date().getFullYear(),
      };
      localStorage.setItem("userData", JSON.stringify(userData));

      // Optional: clear other storages if used (sessionStorage, cookies...)

      // Redirect to login
      // Option A: Best & cleanest – use window.location (works everywhere)
      window.location.href = '/login?session=expired'; // optional query param

      // Option B: If you want to use navigate (requires being inside Router context)
      // → see "Important Notes" below
    }

    // Always reject so .catch() in your components still works if needed
    return Promise.reject(error);
  }
);

export default axiosInstance;